import { isDate } from "../../utils/utils"

/** @internal */
export function useRangeFunctions(date: Date, rangeClosingDate: Date) {

    return React.useMemo(() => getRangeFunctions(date, rangeClosingDate), [date, rangeClosingDate])

}

function getRangeFunctions(date: Date, rangeClosingDate: Date) {

    if (isDate(date) && isDate(rangeClosingDate)) {
        return {
            isLeftDateRangeEnd,
            isRightDateRangeEnd,
            isInDateRange
        }
    }

    return {
        isLeftDateRangeEnd: () => false,
        isRightDateRangeEnd: () => false,
        isInDateRange: () => false
    }

    function isLeftDateRangeEnd(d: Date) {
        //if the date is an interval end (either date or rangeClosingDate), then we use rounded css boundaries
        return (
            (rangeClosingDate.valueOf() == d.valueOf() &&
                d.valueOf() < date.valueOf()) ||
            (date.valueOf() == d.valueOf() &&
                d.valueOf() < rangeClosingDate.valueOf())
        )
    }

    function isRightDateRangeEnd(d: Date) {
        //if the date is an interval end (either date or rangeClosingDate), then we use rounded css boundaries
        return (
            (rangeClosingDate.valueOf() == d.valueOf() &&
                d.valueOf() > date.valueOf()) ||
            (date.valueOf() == d.valueOf() &&
                d.valueOf() > rangeClosingDate.valueOf())
        )
    }

    function isInDateRange(d: Date) {
        return rangeClosingDate.valueOf() < date.valueOf()
            ? rangeClosingDate.valueOf() < d.valueOf() &&
            d.valueOf() < date.valueOf()
            : rangeClosingDate.valueOf() > d.valueOf() &&
            d.valueOf() > date.valueOf()
    }
}
